import { ApiClient } from '../../common/services/apiClient';
import type {
  ActualizarPerfilBody,
  AsignarPerfilBody,
  AsignarPerfilRespuesta,
  CrearPerfilBody,
  Perfil,
} from '../../negocio/negocio.types';

/** Perfiles de Consulta CM (fase 3). Sólo superadmin y admin. */
export class PerfilesService {
  static listar(): Promise<Perfil[]> {
    return ApiClient.get<Perfil[]>('/perfiles');
  }

  static crear(body: CrearPerfilBody): Promise<Perfil> {
    return ApiClient.post<Perfil>('/perfiles', body);
  }

  /** La clave no se cambia: la API responde 400 si llega. */
  static actualizar(id: string, body: ActualizarPerfilBody): Promise<Perfil> {
    return ApiClient.put<Perfil>(`/perfiles/${encodeURIComponent(id)}`, body);
  }

  static async borrar(id: string): Promise<void> {
    await ApiClient.delete(`/perfiles/${encodeURIComponent(id)}`);
  }

  /** Reemplaza el perfil y TODO `perfil_alcance` de la cuenta. */
  static asignar(userId: string, body: AsignarPerfilBody): Promise<AsignarPerfilRespuesta> {
    return ApiClient.put<AsignarPerfilRespuesta>(`/users/${encodeURIComponent(userId)}/perfil`, body);
  }
}
